module.exports = __webpack_public_path__ + "static/media/TEMPLATE1.64c19c64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE1.jpg
// module id = 1467
// module chunks = 1